<template>
  <div id="university" class="margin-subpages">
    <div class="pt-32 px-20 pb-24 chart-container">
      <div class="sub-title px-12">
        <span class="fs-24">{{
          $utils("addCommasInNumber", university_total)
        }}</span>
        {{ $t("happilyVillage.learning_and_activity_interactions") }}
      </div>
      <div class="relative" style="height: 340px">
        <div class="center absolute-mid" v-if="loadingChartStatus">
          <loading-even></loading-even>
        </div>
        <canvas
          ref="universityBarchart"
          height="340px"
          class="barchart-style"
        ></canvas>
      </div>
    </div>
    <div id="universitySessions" class="mt-8">
      <div class="sub-title">
        <span class="fs-24">{{
          $utils("addCommasInNumber", sessionResults)
        }}</span>
        {{ $t("happilyVillage.University_Sessions") }}
      </div>
      <div class="flex-row-between mt-14">
        <div class="relative">
          <el-input
            class="input-style"
            style="height: 40px"
            autosize
            :placeholder="$t('happilyVillage.Search')"
            @keyup.native="typeingSearchSession"
            v-model="inputSearchSession"
            clearable
          ></el-input>
          <!-- <img
            @click="exportTable('universitySesstions')"
            :src="$utils('icons', 'ic_xls_download')"
            class="icon-export"
          />-->
          <download-progress :active="downloadSessionsBar"></download-progress>
        </div>
        <div class="flex-center">
          <el-button
            class="btn-add small"
            size="small"
            icon="el-icon-plus"
            @click="addSession"
            >{{ $t("happilyVillage.add_session") }}</el-button
          >
        </div>
      </div>
      <div class="mt-12">
        <el-table
          class="table-happily-village"
          :data="sessions"
          style="width: 100%"
          @sort-change="sessionSort"
          :empty-text="
            loadingUniversitySessionsTable
              ? ' '
              : !loadingUniversitySessionsTable && inputSearchSession === ''
              ? 'No sessions'
              : 'No session found...'
          "
        >
          <el-table-column
            :label="$t('happilyVillage.Name')"
            sortable="custom"
            width="300"
            prop="class_name"
          >
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.huddles"
                :class="[ blurMode ?  'blurelement': '' ]">
                  <span
                    v-for="(data, index) in scope.row.huddles"
                    :key="data.key"
                  >
                    <span v-if="index < 2" :class="`${spanBgColor(data)}`">{{
                      spanTextTag(data)
                    }}</span>
                    <span v-else-if="index == 2" class="span-tag span-normal"
                      >+ {{ scope.row.huddles.length - 2 }}</span
                    >
                  </span>
                </span>
                <span
                  @click.prevent="showCommentModal(scope.row)"
                  :style="$utils('fontStyle', scope.row.class_name)"
                  class="name-medium cursor-pointer"
                  >{{ scope.row.class_name }}</span
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="create_name"
            sortable="custom"
            :label="$t('happilyVillage.Creator')"
            width="105"
          >
            <template slot-scope="scope">
              <div class="ellipsis normal"
              :class="[ blurMode ?  'blurelement': '' ]">{{ scope.row.create_name }}</div>
            </template>
          </el-table-column>
          <el-table-column
            prop="topic_name"
            sortable="custom"
            :label="$t('happilyVillage.Topic')"
            width="100"
          >
            <template slot-scope="scope">
              <div
                class="ellipsis normal"
                :class="{ 'ml-10': !scope.row.topic_name }"
              >
                {{ scope.row.topic_name ? scope.row.topic_name : "-" }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable="custom"
            :label="$t('happilyVillage.Sign_ups')"
            align="right"
            width="100"
            prop="signup"
          >
            <template slot-scope="scope">
              <div @click.prevent="SignUpsModal(scope.row)" class="link mr-10">
                {{ $utils("addCommasInNumber", scope.row.signup.length) }} /
                {{ $utils("addCommasInNumber", scope.row.class_limit) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable="custom"
            :label="$t('happilyVillage.Engagement')"
            align="right"
            width="125"
            prop="commentsall"
          >
            <template slot-scope="scope">
              <div
                @click.prevent="showCommentModal(scope.row)"
                class="normal mr-10 fc-00B7EE cursor-pointer underline"
              >
                {{ $utils("addCommasInNumber", scope.row.commentsall) }}
                {{ $t("happilyVillage.comment") }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            sortable="custom"
            :label="$t('happilyVillage.Price')"
            align="right"
            width="80"
            prop="class_price"
          >
            <template slot-scope="scope">
              <div class="normal mr-10">
                <template v-if="scope.row.class_price > 1"
                  >{{
                    $utils("addCommasInNumber", scope.row.class_price)
                  }}
                  coins</template
                >
                <template v-else-if="scope.row.class_price == 1"
                  >1 coin</template
                >
                <template v-else>Free</template>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            show-overflow-tooltip
            sortable="custom"
            :label="$t('happilyVillage.Date_and_Time')"
            align="right"
            width="165"
            prop="class_datetime"
          >
            <template slot-scope="scope">
              <div class="normal last">
                {{ removeYear(scope.row.class_datetime) }}
                <span class="more-options">
                  <el-tooltip effect="none" placement="bottom-end">
                    <div slot="content" class="relative">
                      <div class="hamburger-menu">
                        <div
                          @click.prevent="cloneMenu(scope.row, 'duplicate')"
                          class="top"
                        >
                          {{ $t("happilyVillage.Duplicate") }}
                        </div>
                        <div
                          v-if="scope.row.create_user === userLogin.email"
                          @click.prevent="cloneMenu(scope.row, 'edit')"
                          class="top"
                        >
                          {{ $t("happilyVillage.Edit") }}
                        </div>
                        <div
                          @click.prevent="deleteMenu(scope.row)"
                          class="bottom"
                        >
                          {{ $t("happilyVillage.Delete") }}
                        </div>
                      </div>
                    </div>
                    <el-button
                      icon="el-icon-more"
                      size="mini"
                      class="hide"
                      circle
                    ></el-button>
                  </el-tooltip>
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div
          class="center mt-20 mb-40 pt-20 pb-40"
          v-if="loadingUniversitySessionsTable"
        >
          <loading-even></loading-even>
        </div>
        <div class="flex-center pagination mt-10">
          <el-pagination
            @current-change="handleCurrentSessionChange"
            :current-page="1"
            :page-size="10"
            :pager-count="5"
            layout="prev, pager, next"
            :total="sessionResults"
          ></el-pagination>
          <span class="results-status"
            >{{ sessions.length > 10 ? 10 : sessions.length }}
            {{ $t("happilyVillage.results_from") }}
            {{ $utils("addCommasInNumber", sessionResults) }}
            {{ $t("happilyVillage.results") }}</span
          >
        </div>
      </div>
    </div>
    <!-- <div id="onlineCourses" class="mt-32">
      <div class="sub-title">
        <span class="fs-24">{{ $utils('addCommasInNumber', onlineCourses.length) }}</span>
        Online Courses
      </div>
      <div class="flex-row-between mt-14">
        <div class="relative">
          <el-input
            class="input-style"
            style="height: 40px;"
            autosize
            :placeholder="$t('global.Search')"
            v-model="inputSearchCourse"
            clearable
          ></el-input>
          <img
            @click="exportTable('onlineCourses')"
            :src="$utils('icons', 'ic_xls_download')"
            class="icon-export"
          />
          <download-progress :active="downloadCoursesBar"></download-progress>
        </div>
        <div class="flex-center">
          <el-button
            class="btn-add small"
            size="small"
            icon="el-icon-plus"
            @click="addCoursesModal = !addCoursesModal"
          >add courses</el-button>
        </div>
      </div>
      <div class="mt-12">
        <el-table
          class="table-happily-village"
          :data="onlineCourses"
          style="width: 100%;"
          :empty-text="loadingOnlineCoursesTable ? ' ' : !loadingOnlineCoursesTable && inputSearchCourse === '' ? 'No courses' : 'No results found...'"
        >
          <el-table-column label="Name" sortable="custom" width="285">
            <template>
              <div class="name">Basketball Pick-up Games</div>                
            </template>
          </el-table-column>
          <el-table-column sortable="custom" label="Creator" width="105">
            <template>
              <div class="normal ellipsis">Bill Gates</div>
            </template>
          </el-table-column>
          <el-table-column sortable="custom" label="Topic" width="120">
            <template>
              <div class="normal">Technology</div>
            </template>
          </el-table-column>
          <el-table-column sortable="custom" label="Sign ups" align="center" width="100">
            <template>
              <div class="link">{{ $utils('addCommasInNumber', 10) }}</div>
            </template>
          </el-table-column>
          <el-table-column sortable="custom" label="Platform" align="center" width="100">
            <template>
              <div class="normal">iRearn</div>
            </template>
          </el-table-column>
          <el-table-column sortable="custom" label="Price" align="center" width="90">
            <template>
              <div class="normal">{{ $utils('addCommasInNumber', 5) }} coins</div>
            </template>
          </el-table-column>
          <el-table-column show-overflow-tooltip sortable="custom" label="Date and Time" align="right" width="200">
            <template>
              <div class="normal last">
                May 5, 2020 at 11:00 AM
                <span class="more-options">
                  <el-button icon="el-icon-more" size="mini" class="hide" circle></el-button>
                </span>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <div class="center mt-20 mb-40 pt-20 pb-40" v-if="loadingOnlineCoursesTable">
          <loading-even></loading-even>
        </div>
        <div class="flex-center pagination mt-10">
          <el-pagination
            :current-page="1"
            :page-size="5"
            :pager-count="5"
            layout="prev, pager, next"
            :total="universitySessions.length"
          ></el-pagination>
          <span class="results-status">
            {{(onlineCourses.length > 10) ? 10 : onlineCourses.length }} {{ $t('happilyVillage.results_from') }} {{onlineCourses.length}} results
          </span>
        </div>
      </div>
    </div>-->
    <div class="remove-padding-modal">
      <el-dialog :visible.sync="sessionModalStatus" width="930px" top="10vh">
        <div class="grid-2-sesstion">
          <div class="grid-left rm-scrollbar">
            <div class="header flex-center">
              <img
                :src="$utils('icons', 'ic_preview')"
                style="height: 24px; margin-top: -2px"
                class="mr-12"
              />
              <span>{{ $t("happilyVillage.Preview_on_Mobile") }}</span>
            </div>
            <div class="body">
              <div
                v-if="!$utils('watchingTrim', sessionForm.name)"
                class="bg-skeleton height-32"
              ></div>
              <div v-else class="fc-404243 fs-18 fw-900 word-break">
                {{ sessionForm.name.trim() }}
              </div>
              <div v-if="!$utils('watchingTrim', sessionForm.description)">
                <div class="bg-skeleton height-25 mt-24"></div>
                <div class="bg-skeleton height-25 mt-6"></div>
                <div
                  class="bg-skeleton height-25 mt-6"
                  style="width: 70%"
                ></div>
              </div>
              <div v-else class="mt-10 pre-line word-break">
                {{ sessionForm.description }}
              </div>
              <div v-if="mainPreview" class="fc-6C6C6C fs-12">
                <div class="flex mt-34">
                  <img
                    v-if="user.pic"
                    v-lazy="user.pic"
                    :alt="user.firstname + user.lastname"
                    :key="user.pic"
                    class="image-skeleton image-profile-16 mr-8"
                    :class="[ blurMode ?  'blurelement': '' ]"
                  />
                  <div v-else class="image image-profile-16 flex-mid mr-8"
                  :class="[ blurMode ?  'blurelement': '' ]">
                    <div class="text-in-image text-in-image-16 flex-mid">
                      {{
                        $utils("acronymName", {
                          firstName: user.firstname,
                          lastName: user.lastname,
                        })
                      }}
                    </div>
                  </div>
                  <div class="mt-2">
                    {{ $t("happilyVillage.Led_by") }}
                    <span class="fw-700 fc-404243"
                    :class="[ blurMode ?  'blurelement': '' ]"
                      >{{ user.firstname }} {{ user.lastname.charAt(0) }}</span
                    >
                  </div>
                </div>
                <div v-if="sessionForm.dateAndTime" class="flex-center mt-10">
                  <img
                    :src="$utils('icons', 'ic_twotone_cal')"
                    class="mini-icon mt-1"
                  />
                  <div class="ml-8">{{ sessionForm.dateAndTime }}</div>
                </div>
                <div v-if="sessionForm.duration" class="flex-center mt-10">
                  <img
                    :src="$utils('icons', 'ic_twotone_clock')"
                    class="mini-icon"
                  />
                  <div class="ml-8">{{ getHour(sessionForm.duration) }}</div>
                </div>
                <div v-if="sessionForm.location" class="flex-center mt-10">
                  <img
                    :src="$utils('icons', 'ic_twotone_location')"
                    class="mini-icon"
                  />
                  <div class="ml-8">{{ sessionForm.location.trim() }}</div>
                </div>
                <div v-if="sessionForm.sessionLimit + 1 > 0" class="mt-30">
                  <div class="fs-14 ml-6 mb-6">
                    {{ $t("happilyVillage.SIGN_UPS") }} ({{
                      $utils("addCommasInNumber", sessionForm.sessionLimit)
                    }}
                    {{ $t("happilyVillage.spots_available") }})
                  </div>
                  <div class="flex" style="flex-wrap: wrap">
                    <div
                      v-for="index in parseInt(sessionForm.sessionLimit)||0"
                      :key="index"
                      class
                    >
                      <div v-if="index < 109" class="mockup-icon"></div>
                    </div>
                    <div
                      v-if="sessionForm.sessionLimit > 109"
                      class="mt-10 fc-3D8080"
                    >
                      +
                      {{
                        $utils(
                          "addCommasInNumber",
                          sessionForm.sessionLimit - 109
                        )
                      }}
                    </div>
                  </div>
                </div>
              </div>
              <div v-else>
                <div class="flex" style="margin-top: 60px">
                  <div class="bg-skeleton height-cycle"></div>
                  <div class="bg-skeleton height-20"></div>
                </div>
                <div class="flex mt-6">
                  <div class="bg-skeleton height-cycle"></div>
                  <div class="bg-skeleton height-20"></div>
                </div>
                <div class="flex mt-6">
                  <div class="bg-skeleton height-cycle"></div>
                  <div class="bg-skeleton height-20"></div>
                </div>
              </div>
              <div
                v-if="!(sessionForm.sessionLimit + 1 > 0) && !mainPreview"
                class="bg-skeleton height-25 mt-24"
                style="width: 55%; margin-buttom: 100px"
              ></div>
              <div
                class="relative"
                :class="`${
                  !(sessionForm.sessionLimit + 1 > 0) && !mainPreview
                    ? 'mt-40 pt-40'
                    : ''
                }`"
              >
                <div class="flex-center price-box my-40">
                  <div class="fc-B7B7B7 mt-2 pr-20">PRICE</div>
                  <div class="mt-2 coin relative mr-12">&nbsp;</div>
                  <div
                    v-if="sessionForm.price + 1 > 0 && mainPreview"
                    class="fs-18 fw-700 fc-000000 mt-3"
                  >
                    {{ sessionForm.price }}
                  </div>
                  <div v-else class="bg-skeleton height-20" style="width: 20px">
                    &nbsp;
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="grid-right">
            <form id="sessionModal" @submit.prevent="sessionSubmit">
              <div class="title" style="margin-top: 0px">
                {{ $t("happilyVillage.Share_with") }}
              </div>
              <el-tooltip
                class="header-table-tooltip"
                placement="top"
                effect="light"
              >
                <div slot="content">
                  {{ $t("happilyVillage.Huddle_selection_is") }}
                  <br />{{ $t("happilyVillage.Coming_soon_to_the") }}
                </div>
                <el-cascader
                  class="defaulttags"
                  v-model="huddleTag"
                  :placeholder="$t('happilyVillage.Team_or_Name')"
                  :options="huddleTagData"
                  :props="{ multiple: true }"
                  style="width: 100%"
                  filterable
                  :filter-method="filterToFunction"
                  :class="[ blurMode ?  'blurelement': '' ]"
                ></el-cascader>
              </el-tooltip>
              <div class="title" style="margin-top: 0px">
                {{ $t("happilyVillage.Name_of_Session") }}
              </div>
              <el-input
                :placeholder="$t('happilyVillage.Short_but_descriptive_eg')"
                v-model="sessionForm.name"
                class="name"
                :class="{ 'validate-input': validateSessionForm.name }"
              ></el-input>
              <div v-if="validateSessionForm.name" class="validate-worming">
                <div class="text">
                  {{ $t("happilyVillage.Please_input_Name") }}
                </div>
              </div>
              <div class="title">{{ $t("happilyVillage.Description") }}</div>
              <el-input
                type="textarea"
                :autosize="{ minRows: 4, maxRows: 8 }"
                :placeholder="$t('happilyVillage.A_sentence_or_two_about')"
                v-model="sessionForm.description"
                :class="{ 'validate-input': validateSessionForm.description }"
              ></el-input>
              <div
                v-if="validateSessionForm.description"
                class="validate-worming"
              >
                <div class="text">
                  {{ $t("happilyVillage.Please_input_Description") }}
                </div>
              </div>
              <div class="grid-2-auto">
                <div>
                  <div class="title">
                    {{ $t("happilyVillage.Date_and_Time") }}
                  </div>
                  <el-date-picker
                    v-model="sessionForm.dateAndTime"
                    type="datetime"
                    format="MMMM d yyyy h:mm A"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :class="{
                      'validate-input': validateSessionForm.dateAndTime,
                    }"
                    :placeholder="$t('happilyVillage.When')"
                  ></el-date-picker>
                  <div
                    v-if="validateSessionForm.dateAndTime"
                    class="validate-worming"
                  >
                    <div class="text">
                      {{ $t("happilyVillage.Please_input_Date") }}
                    </div>
                  </div>
                </div>
                <div>
                  <div class="title">
                    {{ $t("happilyVillage.Duration_minutes") }}
                  </div>
                  <el-input
                    type="number"
                    :placeholder="$t('happilyVillage.How_long')"
                    v-model="sessionForm.duration"
                    :class="{ 'validate-input': validateSessionForm.duration }"
                  ></el-input>
                  <div
                    v-if="validateSessionForm.duration"
                    class="validate-worming"
                  >
                    <div class="text">
                      {{ $t("happilyVillage.Please_input_Location") }}
                    </div>
                  </div>
                </div>
              </div>
              <div class="title">{{ $t("happilyVillage.Location") }}</div>
              <el-input
                :placeholder="$t('happilyVillage.Where')"
                v-model="sessionForm.location"
                :class="{ 'validate-input': validateSessionForm.location }"
              ></el-input>
              <div v-if="validateSessionForm.location" class="validate-worming">
                <div class="text">
                  {{ $t("happilyVillage.Please_input_Location") }}
                </div>
              </div>
              <div class="grid-2-auto">
                <div>
                  <div class="title">
                    {{ $t("happilyVillage.Session_Limit") }}
                  </div>
                  <el-input
                    type="number"
                    :placeholder="$t('happilyVillage.How_many')"
                    v-model="sessionForm.sessionLimit"
                    :class="{
                      'validate-input': validateSessionForm.sessionLimit,
                    }"
                  ></el-input>
                  <div
                    v-if="validateSessionForm.sessionLimit"
                    class="validate-worming"
                  >
                    <div class="text">
                      {{ $t("happilyVillage.Please_input_Session_Limit") }}
                    </div>
                  </div>
                </div>
                <div>
                  <div class="title">
                    {{ $t("happilyVillage.Price_coins") }}
                  </div>
                  <el-input
                    type="number"
                    :placeholder="$t('happilyVillage.How_much')"
                    v-model="sessionForm.price"
                    :min="0"
                    :disabled="this.editSessionsStatus"
                    :class="{ 'validate-input': validateSessionForm.price }"
                  ></el-input>
                  <div
                    v-if="validateSessionForm.price"
                    class="validate-worming"
                  >
                    <div class="text">
                      {{ $t("happilyVillage.Please_input_rice") }}
                    </div>
                  </div>
                </div>
                <div>
                  <div class="title">
                    {{ $t("happilyVillage.Add_to_Topic") }}
                  </div>
                  <el-select v-model="sessionForm.topic" placeholder="Select">
                    <el-option
                      v-for="item in topicOpt"
                      :key="item.key"
                      :label="item.name"
                      :value="item.key"
                    ></el-option>
                  </el-select>
                </div>
                <div>
                  <div class="title">
                    {{ $t("happilyVillage.Comment_Permissions") }}
                  </div>
                  <el-select
                    v-model="sessionForm.commentPermission"
                    placeholder="Select"
                  >
                    <el-option
                      v-for="item in commentPerm"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    ></el-option>
                  </el-select>
                </div>
              </div>
              <div v-if="editSessionsStatus" class="my-40">
                <el-button
                  class="btn-add bigger"
                  @click.prevent="saveSession"
                  >{{ $t("happilyVillage.Save_Changes") }}</el-button
                >
              </div>
              <div v-else class="my-40">
                <el-button
                  class="btn-add bigger"
                  @click.prevent="sessionSubmit"
                  >{{ $t("happilyVillage.CREATE_SESSION") }}</el-button
                >
                <!-- <el-button
                  class="btn-cancel bigger"
                  @click="saveDraftSessionForm"
                >SAVE AS DRAFT</el-button>-->
              </div>
            </form>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="modal-sign-ups">
      <el-dialog :visible.sync="dialogSignUps" top="8vh">
        <div class="recipients-modal">
          <div>
            <span
              class="fs-20 fw-700 fc-000000 mr-40 word-break"
              :style="$utils('fontStyle', modalSignUps.class_name)"
              >{{ modalSignUps.class_name }}</span
            >
          </div>
          <div class="mt-4 fc-626262">
            Created by {{ modalSignUps.create_name }}
          </div>
          <div class="mt-24 fs-18 fc-000000">
            <span class="fw-700">{{
              $utils("addCommasInNumber", modalSignUps.signup)
            }}</span>
            <span>&nbsp;{{ $t("happilyVillage.sign_ups_of") }}&nbsp;</span>
            <span class="fw-700">{{
              $utils("addCommasInNumber", modalSignUps.class_limit)
            }}</span>
            <span>&nbsp;{{ $t("happilyVillage.available_spots") }}</span>
          </div>
        </div>
        <div class="members-recipients thin-scrollbar">
          <div
            v-for="item in modalSignUps.student"
            :key="item.email"
            class="rowDataStyle"
            :class="[ blurMode ?  'blurelement': '' ]"
          >
            <div class="columnDataStyle" style="width: 100%">
              <div class="flex-center py-7">
                <div v-if="item.image">
                  <img
                    v-lazy="item.image"
                    :key="item.image"
                    class="image-skeleton image-profile-42 flex-mid mr-16"
                  />
                </div>
                <div v-else class="image image-profile-42 flex-mid mr-12">
                  <div
                    class="flex-mid text-in-image text-in-image-42"
                    style="width: 42px"
                  >
                    {{
                      $utils("acronymName", {
                        firstName: item.firstname,
                        lastName: item.lastname,
                      })
                    }}
                  </div>
                </div>
                <div class="flex-column pl-4">
                  <span class="text-name"
                    >{{ item.firstname }} {{ item.lastname }}</span
                  >
                  <span class="text-email">{{ item.email }}</span>
                </div>
              </div>
            </div>
          </div>
          <div v-if="modalSignUps.student.length == 0" class="flex-mid">
            <div class="fs-22 opa-04 p-40 mt-40 mb-30">
              {{ $t("happilyVillage.No_one_sign_up") }}
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
    <div class="comments-modal">
      <el-dialog
        :visible.sync="commentModal"
        width="930px"
        @close="closeCommentModal"
      >
        <div class="grid-2-sesstion">
          <div class="grid-left-no relative thin-scrollbar p-40" style="height: 600px">
            <div class="fc-404243 fs-18 fw-900 word-break">
              {{ commentDetail.title }}
            </div>
            <div
              class="fc-767676 fw-400 fs-14 mt-10 pre-line word-break"
              style="min-height: 40px"
            >
              {{ commentDetail.description }}
            </div>
            <div class="flex mt-34">
              <img
                v-if="commentDetail.creatorImageProfile"
                v-lazy="commentDetail.creatorImageProfile"
                class="image-skeleton image-profile-16 mr-6"
                :src="commentDetail.creatorImageProfile"
                alt=""
                :class="[ blurMode ?  'blurelement': '' ]"
              />
              <div v-else class="image image-profile-16 flex-mid mr-8"
              :class="[ blurMode ?  'blurelement': '' ]">
                <div class="text-in-image text-in-image-16 flex-mid">
                  {{
                    $utils("acronymName", {
                      firstName: user.firstname,
                      lastName: user.lastname,
                    })
                  }}
                </div>
              </div>
              <div class="mt-2">
                {{ $t("happilyVillage.Led_by") }}
                <span class="fw-700 fc-404243"
                :class="[ blurMode ?  'blurelement': '' ]"
                  >{{ commentDetail.firstname }}
                  {{ commentDetail.lastname.charAt(0) }}</span
                >
              </div>
            </div>
            <div v-if="commentDetail.dateAndTime" class="flex-center mt-10">
              <img
                :src="$utils('icons', 'ic_twotone_cal')"
                class="mini-icon mt-1"
              />
              <div class="ml-8">{{ commentDetail.dateAndTime }}</div>
            </div>
            <div v-if="commentDetail.duration" class="flex-center mt-10">
              <img
                :src="$utils('icons', 'ic_twotone_clock')"
                class="mini-icon"
              />
              <div class="ml-8">{{ getHour(commentDetail.duration) }}</div>
            </div>
            <div v-if="commentDetail.location" class="flex-center mt-10">
              <img
                :src="$utils('icons', 'ic_twotone_location')"
                class="mini-icon"
              />
              <div class="ml-8">{{ commentDetail.location.trim() }}</div>
            </div>
            <div v-if="commentDetail.sessionLimit + 1 > 0" class="mt-30">
              <div class="fs-14 ml-6 mb-6">
                {{ $t("happilyVillage.SIGN_UPS") }} ({{
                  $utils(
                    "addCommasInNumber",
                    commentDetail.student.length
                  )
                }}/{{
                  $utils("addCommasInNumber", commentDetail.sessionLimit)
                }}<span>&nbsp;{{ $t("happilyVillage.available_spots") }}</span>)
              </div>
              <div class="flex" style="flex-wrap: wrap">
                <div v-for="value in commentDetail.student" :key="value.id">
                  <img
                    v-if="value.imageProfile"
                    v-lazy="value.imageProfile"
                    class="image-skeleton image-profile-24 mt-6 mr-6"
                    :src="value.imageProfile"
                    alt=""
                    :class="[ blurMode ?  'blurelement': '' ]"
                  />
                  <div v-else class="image image-profile-24 flex-mid mt-6 mr-8"
                  :class="[ blurMode ?  'blurelement': '' ]">
                    <div class="text-in-image text-in-image-24 flex-mid">
                      {{
                        $utils("acronymName", {
                          firstName: value.firstname,
                          lastName: value.lastname,
                        })
                      }}
                    </div>
                  </div>
                </div>
                <div
                  v-for="index in parseInt(commentDetail.sessionLimit) -
                  commentDetail.student.length"
                  :key="index"
                >
                  <div v-if="index < 109" class="mockup-icon"></div>
                </div>
                <div
                  v-if="commentDetail.sessionLimit > 109"
                  class="mt-10 fc-3D8080"
                >
                  +
                  {{
                    $utils(
                      "addCommasInNumber",
                      commentDetail.sessionLimit - 109
                    )
                  }}
                </div>
              </div>
            </div>
            <div class="relative pb-40 pt-40">
              <div class="flex-center price-box">
                <div class="fc-B7B7B7 mt-2 pr-20">PRICE</div>
                <div class="mt-2 coin relative mr-12">&nbsp;</div>
                <div
                  v-if="commentDetail.price + 1 > 0"
                  class="fs-18 fw-700 fc-000000 mt-3"
                >
                  {{ commentDetail.price }}
                </div>
                <div v-else class="bg-skeleton height-20" style="width: 20px">
                  &nbsp;
                </div>
              </div>
            </div>
          </div>
          <div class="grid-right comment-contrainer">
            <div class="fc-404243 fw-900 fs-17">
              {{ $utils("addCommasInNumber", commentDetail.commentsall) }}
              {{ commentDetail.commentsall == 1?  $t("happilyVillage.comment") : "comments" }}
            </div>
            <div class="comment-card mt-12">
              <div class="comment-box thin-scrollbar">
                <div v-if="commentData.length == 0" class="no-comment opa-05">
                  Be the first to comment in this thread
                </div>
                <div v-else class="">
                  <div
                    v-for="(value, valueI) in commentData"
                    :key="value.mparent_id + value.likeorder + valueI"
                  >
                    <div class="comment flex">
                      <div class="content-comment">
                        <img
                          v-if="value.creatorImageProfile"
                          v-lazy="value.creatorImageProfile"
                          class="image-skeleton image-profile-32 mr-12"
                          :src="value.creatorImageProfile"
                          alt=""
                          :class="[ blurMode ?  'blurelement': '' ]"
                        />
                        <div
                          v-else
                          class="image image-profile-32 flex-mid mr-12"
                          :class="[ blurMode ?  'blurelement': '' ]"
                        >
                          <div class="text-in-image text-in-image-32 flex-mid">
                            {{
                              $utils("acronymName", {
                                fullName: value.name,
                              })
                            }}
                          </div>
                        </div>
                        <div class="flex-center">
                          <div class="">
                            <div class="fs-13">
                              <span class="fw-700 fc-AFAFAF"
                              :class="[ blurMode ?  'blurelement': '' ]"
                                >{{ value.name }}&nbsp;</span
                              >
                              <span
                                class="fc-464646 word-break"
                                v-html="urlify(value.value)"
                              ></span>
                            </div>

                            <div v-if="value.image">
                              <img
                                v-lazy="value.image"
                                :alt="value.name"
                                class="img-preview image-skeleton"
                              />
                            </div>
                            <div class="fs-11 fc-AFAFAF flex-center">
                              <div
                                @click="replyComment(value)"
                                class="cursor-pointer"
                                style="color: #70dbcb"
                              >
                                Reply
                              </div>
                              <div>
                                &nbsp;• {{ value.like }} Likes&nbsp;•
                               {{ prettyDate(value.createdate) }} 
                              </div>
                              <div
                                class="flex-center"
                                v-if="value.giftcoin > 0"
                              >
                                &nbsp;•
                                <img
                                  :src="$utils('icons', 'coins-12px')"
                                  alt="icons_coins-12px"
                                  class="mx-4 mb-2"
                                />
                                × {{ value.giftcoin }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="flex-mid">
                        <img
                          v-if="value.liked === false"
                          @click.prevent="likeOrUnlike(value)"
                          :src="$utils('icons', 'btn_like_off_32px')"
                          alt="icons_btn_like_off_32px"
                          class="cursor-pointer"
                        />
                        <img
                          v-else
                          @click.prevent="likeOrUnlike(value)"
                          :src="$utils('icons', 'btn_like_on_32px')"
                          alt="icons_btn_like_on_32px"
                          class="cursor-pointer"
                        />
                      </div>
                    </div>
                    <div
                      v-for="(subValue, index) in value.subComment"
                      :key="
                        value.mparent_id +
                        subValue.likeorder +
                        valueI +
                        value.likeorder +
                        index
                      "
                      class="comment flex"
                    >
                      <div class="content-comment-sub">
                        <img
                          :src="$utils('icons', 'ic_reply_arrow_24px')"
                          alt="icons_ic_reply_arrow_24px"
                        />
                        <img
                          v-if="subValue.creatorImageProfile"
                          v-lazy="subValue.creatorImageProfile"
                          class="image-skeleton image-profile-32 mr-12"
                          :src="subValue.creatorImageProfile"
                          alt=""
                        />
                        <div
                          v-else
                          class="image image-profile-32 flex-mid mr-12"
                        >
                          <div class="text-in-image text-in-image-32 flex-mid">
                            {{
                              $utils("acronymName", {
                                fullName: subValue.name,
                              })
                            }}
                          </div>
                        </div>
                        <div class="flex-center">
                          <div class="">
                            <div class="fs-13">
                              <span class="fw-700 fc-AFAFAF"
                                >{{ subValue.name }}&nbsp;</span
                              >
                              <span
                                class="fc-464646 word-break"
                                v-html="urlify(subValue.value)"
                              ></span>
                            </div>
                            <div v-if="subValue.image">
                              <img
                                v-lazy="subValue.image"
                                :alt="subValue.name"
                                class="img-preview image-skeleton"
                              />
                            </div>
                            <div class="fs-11 fc-AFAFAF flex-center">
                              <div
                                @click="replyComment(subValue)"
                                class="cursor-pointer"
                                style="color: #70dbcb"
                              >
                                Reply
                              </div>
                              <div>
                                &nbsp;• {{ subValue.like }} Likes&nbsp;•
                               {{ prettyDate(subValue.createdate) }}
                              </div>
                              <div
                                class="flex-center"
                                v-if="subValue.giftcoin > 0"
                              >
                                &nbsp;•
                                <img
                                  :src="$utils('icons', 'coins-12px')"
                                  alt="icons_coins-12px"
                                  class="mx-4 mb-2"
                                />
                                × {{ subValue.giftcoin > 0 }}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="flex-mid">
                        <img
                          v-if="subValue.liked == false"
                          @click.prevent="replylikeOrUnlike(subValue)"
                          :src="$utils('icons', 'btn_like_off_32px')"
                          alt="icons_btn_like_off_32px"
                          class="cursor-pointer"
                        />
                        <img
                          v-else
                          @click.prevent="replylikeOrUnlike(subValue)"
                          :src="$utils('icons', 'btn_like_on_32px')"
                          alt="icons_btn_like_on_32px"
                          class="cursor-pointer"
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div id="comment_data_bottom_university"></div>
              </div>
              <div class="input-container flex-center">
                <img
                  v-if="userLogin.profilepic"
                  v-lazy="userLogin.profilepic"
                  class="image-skeleton image-profile-32 mr-12"
                  :src="userLogin.profilepic"
                  alt=""
                  :class="[ blurMode ?  'blurelement': '' ]"
                />
                <div v-else class="image image-profile-32 flex-mid mr-12"
                :class="[ blurMode ?  'blurelement': '' ]">
                  <div class="text-in-image text-in-image-32 flex-mid">
                    {{
                      $utils("acronymName", {
                        firstName: userLogin.firstname,
                        lastName: userLogin.lastname,
                      })
                    }}
                  </div>
                </div>
                <div
                  class="relative input-contain"
                  style="display: grid; grid-template-columns: auto 1fr"
                >
                  <div class="flex-center">
                    <div
                      v-if="replyCommentData.name"
                      class="reply-tag ml-6 flex-center"
                      :class="[ blurMode ?  'blurelement': '' ]"
                    >
                      <img
                        :src="$utils('icons', 'ic_reply_arrow_small_16px')"
                        alt="icons_ic_reply_arrow_small_16px"
                      />
                      {{ replyCommentData.name }}
                    </div>
                  </div>
                  <input
                    v-model="messageInput"
                    @keyup="searchMember(messageInput)"
                    class="input-box"
                    type="text"
                    :placeholder="
                      replyCommentData.name
                        ? 'Reply here...'
                        : 'Comment here...'
                    "
                  />
                  <div
                    class="mention-container thin-scrollbar"
                    :style="mentionsTopPosition(this.searchMemberArr.length)"
                    v-if="this.searchMemberArr.length > 0"
                  >
                    <div
                      class="memeber-box flex-center"
                      @click="mentionToText(mem)"
                      v-for="mem in this.searchMemberArr"
                      :key="mem.id + '_searching'"
                    >
                      <div>
                        <div>{{ mem.fullname }}</div>
                        <div class="opa-08 fs-10">{{ mem.email }}</div>
                      </div>
                    </div>
                  </div>
                </div>
                <img
                  v-if="replyCommentData.user && messageInput"
                  @click="submitReply"
                  src="@/assets/images/happilyvillage/btn-send.png"
                  alt="icons_btn_like_on_32px"
                  class="ml-auto cursor-pointer"
                />
                <img
                  v-else-if="replyCommentData.user"
                  @click="clearReplyData"
                  src="@/assets/images/happilyvillage/btn-reply-cancel.png"
                  alt="icons_btn_like_on_32px"
                  class="ml-auto cursor-pointer"
                />
                <img
                  v-else
                  @click="submitMessage"
                  src="@/assets/images/happilyvillage/btn-send.png"
                  alt="icons_btn_like_on_32px"
                  class="ml-auto cursor-pointer"
                />
              </div>
            </div>
          </div>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Chart from "chart.js/auto";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { min } from "date-fns";
import format from "date-fns/format";
import team from "@/store/team";
import moment from "moment";

export default {
  name: "university",
  components: {
    loadingEven: require("../even/loading").default,
    downloadProgress: require("../even/download-progress").default,
  },
  created() {
    this.$store.dispatch(
      "happilyvillageUniversity/getHouseAndTeam",
      this.userLogin
    );
    this.$store.dispatch("happilyvillageUniversity/getUser", this.userLogin);
  },
  watch: {
    university_graphmonth() {
      if (this.university_bar_chart) {
        this.university_bar_chart.destroy();
      }
      this.randerBarChartUniversity();
    },
    inputSearchSession() {
      if (!this.inputSearchSession) {
        this.typeingSearchSession();
      }
    },
  },
  computed: {
    userLogin() {
      return this.$store.getters["authen/user"];
    },
    allusers() {
      return this.$store.getters["happilyvillage/allusers"];
    },
    sessions() {
      return this.$store.getters["happilyvillageUniversity/sessions"];
    },
    topicOpt() {
      return this.$store.getters["happilyvillageUniversity/topicOpt"];
    },
    universityall() {
      return this.$store.getters["happilyvillageUniversity/universityall"];
    },
    university_graphmonth() {
      return this.$store.getters[
        "happilyvillageUniversity/university_graphmonth16"
      ];
    },
    university_total() {
      return this.$store.getters["happilyvillageUniversity/university_total16"];
    },
    inputSearchSession: {
      get() {
        return this.$store.getters[
          "happilyvillageUniversity/inputSearchSessions"
        ];
      },
      set(value) {
        this.$store.commit("happilyvillageUniversity/setInputSearchSessions", {
          keyword: value,
        });
      },
    },
    sessionResults() {
      return this.$store.getters["happilyvillageUniversity/sessionResults"];
    },
    loadingUniversitySessionsTable() {
      return this.$store.getters[
        "happilyvillageUniversity/loadingUniversitySessionsTable"
      ];
    },
    mainPreview() {
      let statusSession =
        this.$utils("watchingTrim", this.sessionForm.name) &&
        this.$utils("watchingTrim", this.sessionForm.description);
      return statusSession || false;
    },
    huddleTagData() {
      return this.$store.getters["happilyvillageUniversity/huddleTagData"];
    },
    commentData() {
      this.scrollToBottomComments();
      return this.$store.getters["happilyvillageUniversity/comment"];
    },
    userAll(){
       return this.$store.getters["happilyvillageUniversity/userAll"];
    },
    commentId() {
      return this.$store.getters["happilyvillageUniversity/commentId"];
    },
    member() {
      return this.$store.getters["happilyvillageUniversity/member"];
    },
    blurMode() {
      return this.$store.getters["demomode/blurMode"];
    },
  },
  data() {
    return {
      id: "",
      universitySessions: [],
      loadingChartStatus: true,
      sessionModalStatus: false,
      sessionModalType: "create",
      commentModal: false,
      downloadSessionsBar: false,
      onlineCourses: [],
      loadingOnlineCoursesTable: false,
      inputSearchCourse: null,
      addCoursesModal: false,
      downloadCoursesBar: false,
      dialogSignUps: false,
      editSessionsStatus: false,
      modalSignUps: {
        class_name: "",
        create_name: "",
        signup: 0,
        class_limit: 0,
        student: [],
      },
      user: {
        pic: null,
        firstname: "Firstname",
        lastname: "Lastname",
        name: "Firstname L",
      },
      sessionForm: {
        name: "",
        description: "",
        dateAndTime: "",
        duration: null,
        location: "",
        sessionLimit: null,
        price: null,
        topic: null,
        commentPermission: 1,
      },
      validateSessionForm: {
        name: false,
        description: false,
        dateAndTime: false,
        duration: false,
        location: false,
        sessionLimit: false,
        price: false,
        topic: false,
      },
      commentPerm: [
        { value: 1, label: "Anyone can comment" },
        { value: 2, label: "Only signees can comment" },
        { value: 3, label: "Only me" },
      ],
      huddleTag: [["everyone"]],
      commentDetail: {
        title: "Today’s Magic Word: +200 coins Giveaway!",
        description: "",
        creator: "Tony S",
        firstname: "Tony",
        lastname: "Stark",
        creatorImageProfile: "",
        dateAndTime: "2022-07-15 03:00:00",
        duration: 60,
        location: "Siam center",
        sessionLimit: 30,
        student: [
          {
            id: "fasdfjlsdaf",
            firstname: "Tony",
            lastname: "Stark",
            imageProfile: "",
          },
        ],
        price: 3,
      },
      // commentData: [
      //   {
      //     comments: 0,
      //     company: "-Kv0X8SSurYL3y1MZAWL",
      //     createdate: "2022-07-04 12:27:44",
      //     creatorImageProfile:
      //       "https://firebasestorage.googleapis.com/v0/b/people2-admin.appspot.com/o/images%2Fprofiles2%2F-Kv0X8SSurYL3y1MZAWL%2Fcrop%2Fpatchara_k@dhas.com_20211018113842.jpg?alt=media&rand=777",
      //     key: "q5cIylpbSxIm9frXRZzj",
      //     like: 0,
      //     liked: false,
      //     likeorder: 999920220704122800,
      //     mparent_id: "xGkFYAKVDk9B35nUG3R5",
      //     name: "Patchara K",
      //     type: "townhall",
      //     user: "patchara_k@dhas.com",
      //     value: "Starwars",
      //   },
      // ],
      messageInput: "",
      searchMemberArr: [],
      // member: [
      //   {
      //     name: "AA",
      //     firstname: "Ali",
      //     fullname: "Ali Alies",
      //     email: "ali_a@email.com",
      //     id: "ali1B111",
      //   },
      //   {
      //     name: "BB",
      //     firstname: "Beatriz",
      //     fullname: "Beatriz Beatroze",
      //     email: "beatriz_b@email.com",
      //     id: "beatriz1N111",
      //   },
      //   {
      //     name: "BB",
      //     firstname: "Ceatriz",
      //     fullname: "Ceatriz Mit",
      //     email: "ceatriz_m@email.com",
      //     id: "beatrizM1111",
      //   },
      //   {
      //     name: "BB",
      //     firstname: "Meatriz",
      //     fullname: "Meatriz Hrolla",
      //     email: "meatriz_h@email.com",
      //     id: "beatriz1111",
      //   },
      //   {
      //     name: "CT",
      //     firstname: "Charles",
      //     fullname: "Charles Prello",
      //     email: "charles_p@email.com",
      //     id: "charles1111",
      //   },
      //   {
      //     name: "DM",
      //     firstname: "Diya",
      //     fullname: "Diya Mania",
      //     email: "diya_m@email.com",
      //     id: "diya1111",
      //   },
      //   {
      //     name: "EP",
      //     firstname: "Eric",
      //     fullname: "Eric Poomchai",
      //     email: "eric_p@email.com",
      //     id: "aeric1111",
      //   },
      //   {
      //     name: "TG",
      //     firstname: "Tarin",
      //     fullname: "Tarin Gurin",
      //     email: "tarin@email.com",
      //     id: "aeric111tad231",
      //   },
      // ],
      replyCommentData: {
        company: "",
        createdate: "",
        likeorder: 0,
        mparent_id: "",
        name: "",
        type: "",
        user: "",
        value: "",
      },
      sessionId:'',
      mention: [],
      statusUpdate: false,
      currentPage: 1,
      // huddleTagData: [
      //   {
      //     value: "everyone",
      //     label: "Everyone",
      //   },
      // ],
    };
  },
  mounted() {
    if (this.university_bar_chart) {
      this.university_bar_chart.destroy();
    }
    this.randerBarChartUniversity();
  },
  methods: {
    getHour(duration) {
      if (duration) {
        let min = duration || 0;
        let hour = Math.floor(min / 60);
        if (1 <= hour) {
          min = min - hour * 60;
          if (min) {
            return `${hour} hr ${min} min`;
          } else {
            return `${hour} hr`;
          }
        } else {
          return `${min} min`;
        }
      }
      return "";
    },
    mentionsTopPosition(value) {
      // 140
      let style = "-46px";
      if (value > 3) {
        style = "-146px";
      } else if (value == 3) {
        style = "-126px";
      } else if (value == 2) {
        style = "-86px";
      }
      return "top: " + style;
    },
    async scrollToBottomComments() {
      for (let i = 0; i < 6; i++) {
        await this.$utils("waitingTime", 400);
        this.scrollIntoView();
      }
    },
    scrollIntoView() {
      const element = document.getElementById("comment_data_bottom_university");
      if (element) {
        element.scrollIntoView();
      }
    },
    closeCommentModal() {
      this.commentModal = false;
      if (this.statusUpdate == true) {
        this.$store.commit("happilyvillageUniversity/setSession", []);
        this.$store.commit(
          "happilyvillageUniversity/setLoadingSessionsTable",
          true
        );
        this.$store.dispatch("happilyvillageUniversity/getUniversity").then(() => {
        this.$store.dispatch(
            "happilyvillageUniversity/currentSessionsChange",
            this.currentPage
          );
        });
      }
    },
    likeOrUnlike(value) {
      this.$store.dispatch("happilyvillageUniversity/likeOrUnLike", {
        form: value,
      });
      let commentData = _.find(this.commentData, function (o) {
        return o.key === value.key;
      });
      if (commentData.liked == true) {
        commentData.liked = false;
      } else {
        commentData.liked = true;
      }
    },
    replylikeOrUnlike(value) {
      this.$store.dispatch("happilyvillageUniversity/replylikeOrUnlike", {
        form: value,
      });
      let commentData = _.find(this.commentData, function (o) {
        return o.key === value.maprent_id2;
      });
      let subCommentData = _.find(commentData.subComment, function (o) {
        return o.key === value.key;
      });
      if (subCommentData.liked == true) {
        subCommentData.liked = false;
      } else {
        subCommentData.liked = true;
      }
    },
    replyComment(value) {
      if (value.maprent_id2) {
        let commentData = _.find(this.commentData, function (o) {
          return o.key === value.maprent_id2;
        });
        this.replyCommentData = JSON.parse(JSON.stringify(commentData));
      } else {
        this.replyCommentData = JSON.parse(JSON.stringify(value));
      }
      
    },
    clearReplyData() {
      this.replyCommentData.company = "";
      this.replyCommentData.createdate = "";
      this.replyCommentData.likeorder = 0;
      this.replyCommentData.mparent_id = "";
      this.replyCommentData.name = "";
      this.replyCommentData.type = "";
      this.replyCommentData.user = "";
      this.replyCommentData.value = "";
    },
    searchMember(str) {
      const regex = /\B@[a-z0-9_-]+/gi;
      const members = str.match(regex);
      if (members && members.length > 0) {
        const filterStr = this.checkUserAdded(str);
        const membersFilter = filterStr.match(regex);
        if (
          membersFilter &&
          membersFilter.length > 0 &&
          filterStr.search(membersFilter + " ") < 0
        ) {
          const searchName = membersFilter[membersFilter.length - 1];
          let filtered = _.filter(this.member, (item) => {
            return (
              item.fullname
                .toLowerCase()
                .indexOf(searchName.toLowerCase().slice(1, searchName.length)) >
              -1
            );
          });
          if (filtered.length < this.member.length) {
            this.searchMemberArr = filtered;
          } else {
            this.searchMemberArr = [];
          }
        } else {
          this.searchMemberArr = [];
        }
      } else {
        this.searchMemberArr = [];
      }
    },
    urlify(text) {
      let urlRegex =
        /(\b(https?|http?|ftp|file):\/\/[-A-Z0-9+&@#\/%?=~_|!:,.;]*[-A-Z0-9+&@#\/%=~_|])/gi;
      return text.replace(urlRegex, (url) => {
        return '<a href="' + url + '">' + url + "</a>";
      });
    },
    checkUserAdded(str) {
      let text = str;
      const regex = /\B@[a-z0-9_-]+/gi;
      const members = str.match(regex);
      for (let i = 0; i < this.mention.length; i++) {
        text = text.replace("@" + this.mention[i].firstname, "");
      }
      let mention = [];
      members.map((v) => {
        let _findmention = _.find(this.mention, function (value) {
          return value.mention  === v;
        });
        if (_findmention) {
          mention.push(_findmention);
        }
      });
      this.mention = mention;
      return text;
    },
    mentionToText(value) {
      const str = this.messageInput;
      const regex = /\B@[a-z0-9_-]+/gi;
      const members = str.match(regex);
      if (members && members.length > 0) {
        const filterStr = this.checkUserAdded(str);
        let membersFilter = filterStr.match(regex);
        if (membersFilter && membersFilter.length > 0) {
          this.messageInput = this.messageInput.replace(
            membersFilter[membersFilter.length - 1],
            "@" + value.firstname + " "
          );

           this.mention.push({...value,mention:"@" + value.firstname});

          this.searchMemberArr = [];
        }
      }
    },
    submitReply() {
      let key = this.replyCommentData.key;
      let notifications = [];
      this.mention.map((v) => {
        notifications.push({ email: v.email, name: v.name });
      });
      let likeorder = parseInt(
        "9999" +
          moment()
            .utc()
            .add(this.userLogin.timezone, "hours")
            .format("YYYYMMDDHHmmss")
      );
      let data = {
        comments: 0,
        company: this.userLogin.company,
        createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
        like: 0,
        likeorder: likeorder,
        liked: false,
        mparent_id: this.sessionId,
        maprent_id2: this.replyCommentData.key,
        name:
          this.userLogin.firstname + " " + this.userLogin.lastname.charAt(0),
        notifications: notifications,
        type: "session",
        user: this.userLogin.email,
        value: this.messageInput,
      };

      let commentData = _.find(this.commentData, function (o) {
        return o.key == key;
      });
      commentData.subComment.push({
        ...data,
        creatorImageProfile: this.userLogin.profilepic_crop,
      });
      this.$store
        .dispatch("happilyvillageUniversity/replyComment", {
          sessionId: this.sessionId,
          comment: this.replyCommentData,
          message: this.messageInput,
          likeorder: likeorder,
          notifications:notifications,
        })
        .then(() => {
          this.messageInput = "";
          this.statusUpdate = true;
        });

      this.clearReplyData();
      this.clearReplyData();
    },
    submitMessage() {
      let notifications = [];
      this.mention.map((v) => {
        notifications.push({ email: v.email, name: v.name });
      });
      let likeorder = parseInt(
        "9999" +
          moment()
            .utc()
            .add(this.userLogin.timezone, "hours")
            .format("YYYYMMDDHHmmss")
      );

      let data = {
        comments: 0,
        company: this.userLogin.company,
        createdate: format(new Date(), "YYYY-MM-DD HH:mm:ss"),
        like: 0,
        likeorder: likeorder,
        liked: false,
        mparent_id: this.sessionId,
        name:
          this.userLogin.firstname + " " + this.userLogin.lastname.charAt(0),
        notifications: notifications,
        subComment: [],
        type: "session",
        user: this.userLogin.email,
        value: this.messageInput,
      };
      this.commentData.push({
        ...data,
        creatorImageProfile: this.userLogin.profilepic_crop,
      });
      this.$store
        .dispatch("happilyvillageUniversity/comment", {
          sessionId: this.sessionId,
          message: this.messageInput,
          likeorder: likeorder,
          notifications:notifications,
        })
        .then(() => {
          let commentData = _.find(this.commentData, function (o) {
            return !o.key;
          });
          commentData.key = this.commentId;
          this.messageInput = "";
          this.statusUpdate = true;
        });
    },
    showCommentModal(value) {
      let signup=[]
      this.commentDetail.title= value.class_name;
      this.commentDetail.description= value.class_description;
      this.commentDetail.dateAndTime=moment(value.class_datetime).format("MMMM DD, YYYY h:mm A");
      this.commentDetail.location=value.class_location;
      this.commentDetail.duration=value.minutes;
      this.commentDetail.price=value.class_price;
      this.commentDetail.sessionLimit=value.class_limit
      this.commentDetail.commentsall=value.commentsall
      if (this.userAll[value.create_user]) {
        this.commentDetail.creatorImageProfile =this.userAll[value.create_user].profilepic_crop || "";
        this.commentDetail.firstname= this.userAll[value.create_user].firstname
        this.commentDetail.lastname= this.userAll[value.create_user].lastname
        this.commentDetail.creator=  value.create_name
      } else {
        this.commentDetail.creatorImageProfile = "";
      }
      value.signup.map((v)=>{
        if(this.userAll[v.email]){
          signup.push({
            id: v.email,
            firstname:this.userAll[v.email].firstname,
            lastname: this.userAll[v.email].lastname,
            imageProfile:this.userAll[v.email].profilepic_crop,
        })
        }else {
          signup.push({
            id: v.email,
            firstname:"",
            lastname: "",
            imageProfile:"",
        })
        }
      })
      
      this.commentDetail.student=signup
 
      this.$store
        .dispatch("happilyvillageUniversity/getComment", { id: value.key })
        .then(() => {
          this.commentModal = true;
          this.sessionId = value.key;
          this.scrollToBottomComments();
        });
    },
    addSession() {
      this.cancelSessionModal();
      this.setUser(this.userLogin);
      this.sessionModalStatus = true;
    },
    setUser(userData) {
      this.user.firstname = userData.firstname;
      this.user.lastname = userData.lastname;
      this.user.name = userData.firstname + " " + userData.lastname.charAt(0);
      if (userData.profilepic_small) {
        this.user.pic = userData.profilepic_small;
      } else if (userData.profilepic_crop) {
        this.user.pic = userData.profilepic_crop;
      } else if (userData.profilepic) {
        this.user.pic = userData.profilepic;
      } else {
        this.user.pic = null;
      }
    },
    exportTable(val) {
      console.log("Export excel file" + val); // TODO: Export excel file funcion!
      if (val === "onlineCourses") {
        this.downloadSessionsBar = true;
        setTimeout(() => {
          this.downloadSessionsBar = false;
        }, 2000);
      } else if (val === "universitySesstions") {
        this.downloadCoursesBar = true;
        setTimeout(() => {
          this.downloadCoursesBar = false;
        }, 2000);
      }
    },
    randerBarChartUniversity() {
      var universityBarchart = this.$refs.universityBarchart;
      const months = [];
      const value = [];
      for (const x in this.university_graphmonth) {
        months.push(this.university_graphmonth[x].month);
        value.push(this.university_graphmonth[x].value);
      }
      // Reverse the arrays to show oldest months first
      months.reverse();
      value.reverse();

      if (universityBarchart) {
        this.loadingChartStatus = false;
        const universityBarChartData = {
          labels: months,
          datasets: [
            {
              label: "Learning Interactions",
              data: value,
              backgroundColor: "#d6c3eb",
              borderColor: "#6C30CC",
              borderWidth: 1,
              datalabels: {
                color: "#6C30CC",
              },
            },
          ],
        };
        const options = JSON.parse(JSON.stringify(this.variable.chartOptioins));
        options.plugins.tooltip = {
          enabled: false,
        };
        (options.layout = {
          padding: {
            top: 24,
          },
        }),
          (this.university_bar_chart = new Chart(
            universityBarchart.getContext("2d"),
            {
              plugins: [ChartDataLabels],
              type: "bar",
              data: universityBarChartData,
              options: options,
            }
          ));
      }
    },
    sessionSort({ column, prop, order }) {
      if (order) {
        this.$store.dispatch("happilyvillageUniversity/sortSesstions", [
          column.property,
          order,
        ]);
      }
    },
    handleCurrentSessionChange(val) {
      this.currentPage = val;
      this.$store.dispatch(
        "happilyvillageUniversity/currentSessionsChange",
        val
      );
    },
    typeingSearchSession() {
      this.$store.dispatch("happilyvillageUniversity/searchSessions", {
        value: this.inputSearchSession,
        typingTimeout: this.variable.typingTimeout,
      });
    },
    sessionSubmit() {
      let validateData = this.validateForm();
      if (validateData) {
        let form = [];
        form = _.clone(this.sessionForm);
        this.$store
          .dispatch("happilyvillageUniversity/createSession", {
            form: form,
            huddles: this.huddleTag,
          })
          .then(() => {
            this.sessionModalStatus = false;
            this.cancelSessionModal();
          });
        this.$message({
          type: "success",
          message: "New session has been created",
        });
      }
    },
    saveSession() {
      let validateData = this.validateForm();
      if (validateData) {
        let form = [];
        let id = _.clone(this.id);
        form = _.clone(this.sessionForm);
        this.$store
          .dispatch("happilyvillageUniversity/editSession", {
            form: form,
            id: id,
            huddles: this.huddleTag,
          })
          .then(() => {
            this.sessionModalStatus = false;
            this.cancelSessionModal();
          });
        this.$message({
          type: "success",
          message: "Session has been updated",
        });
      }
    },
    saveDraftSessionForm() {
      let validateData = this.validateForm();
      if (validateData) {
        setTimeout(() => {
          // remove timeout and Create functions no this line!
          this.sessionModalStatus = false;
          console.log("Saved Draft", this.sessionForm); // TODO: Save draft function!
        }, 500);
      }
    },
    validateForm() {
      if (this.sessionForm.price === 0) {
        this.sessionForm.price = 3.14159;
      }
      let value = [
        "name",
        "description",
        "dateAndTime",
        "duration",
        "location",
        "sessionLimit",
        "price",
        "topic",
      ];
      for (let i = 0; i < value.length; i++) {
        this.validateSessionForm[value[i]] = true;
        let status = this.$utils(
          "watchingTrim",
          this.sessionForm[value[i]] || ""
        );
        if (status) {
          this.validateSessionForm[value[i]] = false;
        }
      }
      let name =
        this.$utils("watchingTrim", this.sessionForm.name) &&
        this.$utils("watchingTrim", this.sessionForm.description) &&
        this.$utils("watchingTrim", this.sessionForm.dateAndTime) &&
        this.$utils("watchingTrim", this.sessionForm.duration || "") &&
        this.$utils("watchingTrim", this.sessionForm.location) &&
        this.$utils("watchingTrim", this.sessionForm.sessionLimit || "") &&
        this.$utils("watchingTrim", this.sessionForm.price || "");
        this.$utils("watchingTrim", this.sessionForm.topic || "");
      if (this.sessionForm.price === 3.14159) {
        this.sessionForm.price = 0;
      }
      return name;
    },
    SignUpsModal(val) {
      this.modalSignUps.class_name = val.class_name;
      this.modalSignUps.create_name = val.create_name;
      this.modalSignUps.signup = val.signup.length;
      this.modalSignUps.class_limit = val.class_limit;
      if (val.signup.length > 0) {
        let studentArr = [];
        for (const x in val.signup) {
          let _item = val.signup[x];
          let emailKey = _item.email.replace(/\./g, "||");
          _item.firstname = this.allusers[emailKey]
            ? this.allusers[emailKey].firstname
            : "";
          _item.lastname = this.allusers[emailKey]
            ? this.allusers[emailKey].lastname
            : "";
          if (this.allusers[emailKey]) {
            if (this.allusers[emailKey]["profilepic_small"]) {
              _item.image = this.allusers[emailKey]["profilepic_small"];
            } else if (this.allusers[emailKey]["profilepic_crop"]) {
              _item.image = this.allusers[emailKey]["profilepic_crop"];
            } else if (this.allusers[emailKey]["profilepic"]) {
              _item.image = this.allusers[emailKey]["profilepic"];
            } else {
              _item.image = "";
            }
          }
          studentArr.push(_item);
        }
        this.modalSignUps.student = studentArr;
      } else {
        this.modalSignUps.student = [];
      }
      // this.modalSignUps.student = val.signup; // Add students data here <<<
      this.dialogSignUps = true;
    },
    removeYear(dateTime) {
      return format(dateTime, "MMM D [at] H:mm A");
    },
    reformatForCalenda(str) {
      let removeComma = str.split(",");
      let removeAt = removeComma.join("").split(" at");
      return removeAt.join(",");
    },
    cloneMenu(value, select) {
      this.resetValidateForm();
      this.sessionForm.name = value.class_name || "";
      this.sessionForm.description = value.class_description || "";
      this.sessionForm.duration = value.minutes || null;
      this.sessionForm.location = value.class_location || "";
      this.sessionForm.sessionLimit = value.class_limit || null;
      this.sessionForm.price = (value.class_price || value.class_price == 0 || value.class_price == '0') ? value.class_price : null;
      this.sessionForm.topic = value.topic_id || null;
      this.sessionForm.commentPermission = value.comment_type;
      this.setUser(this.userLogin);
      if (select === "edit") {
        this.id = value.key;
        this.sessionForm.dateAndTime = value.class_datetime || "";
        this.editSessionsStatus = true;
      } else {
        this.id = "";
        this.sessionForm.dateAndTime = "";
        this.editSessionsStatus = false;
      }
      this.sessionModalStatus = true;
    },
    resetValidateForm() {
      this.validateSessionForm.name = false;
      this.validateSessionForm.description = false;
      this.validateSessionForm.dateAndTime = false;
      this.validateSessionForm.duration = false;
      this.validateSessionForm.location = false;
      this.validateSessionForm.sessionLimit = false;
      this.validateSessionForm.price = false;
      this.validateSessionForm.topic = false;
    },
    deleteMenu(value) {
      this.$confirm(
        `Are you sure you would like to proceed with "${value.class_name}"? deleting This action cannot be undone.`,
        "Confirm to Delete",
        {
          confirmButtonText: "Confirm",
          cancelButtonText: "Cancel",
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$store.dispatch("happilyvillageUniversity/deleteSession", value);
          this.$message({
            type: "success",
            message: "Delete completed",
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "Delete canceled",
          });
        });
    },
    cancelSessionModal() {
      this.id = "";
      this.editSessionsStatus = false;
      this.sessionForm.name = "";
      this.sessionForm.description = "";
      this.sessionForm.dateAndTime = "";
      this.sessionForm.duration = null;
      this.sessionForm.location = "";
      this.sessionForm.sessionLimit = null;
      this.sessionForm.price = null;
      this.sessionForm.topic = null;
      this.sessionForm.commentPermission = 1;

      this.user.pic = null;
      this.user.firstname = "Firstname";
      this.user.lastname = "Lastname";
      this.user.name = "Firstname L";

      this.resetValidateForm();
    },
    spanBgColor(value) {
      if (value.house) {
        switch (value.key) {
          case "-LWOr-XsbZM2digYl1QL":
            return "span-tag bg-1d97f2";
            break;
          case "-LWPrOElCYViBd6j6qP-":
            return "span-tag bg-ffbf1f";
            break;
          default:
            return "span-tag bg-ea183c";
        }
      } else if (value.team) {
        return "span-tag span-normal";
      }
    },
    spanTextTag(value) {
      if (value.house) {
        switch (value.key) {
          case "-LWOr-XsbZM2digYl1QL":
            return "Delphinus";
            break;
          case "-LWPrOElCYViBd6j6qP-":
            return "Leonos";
            break;
          default:
            return "Corvus";
        }
      } else if (value.team) {
        return value.value;
      }
    },
    filterToFunction(node, keyword) {
      let space = keyword.split(" ");
      let comma = keyword.split(",");
      let commaAndSpace = keyword.split(", ");
      let keywordArr = comma;
      if (space.length > comma.length) {
        keywordArr = space;
      } else if (
        commaAndSpace.length > comma.length ||
        commaAndSpace.length > space.length
      ) {
        keywordArr = commaAndSpace;
      }
      if (keywordArr.length > 1) {
        for (let i = 0; i < keywordArr.length; i++) {
          if (node.data.toType == "user") {
            if (
              node.data.firstname
                .toLowerCase()
                .indexOf(keywordArr[i].toLowerCase()) === 0
            ) {
              node.text = node.data.firstname + " " + node.data.lastname;
              return true;
            } else if (
              node.data.lastname
                .toLowerCase()
                .indexOf(keywordArr[i].toLowerCase()) === 0
            ) {
              node.text = node.data.firstname + " " + node.data.lastname;
              return true;
            } else if (keywordArr[i].trim() === node.data.email) {
              this.dynamicValidateForm.cascaderTo.push([
                "user_" + node.data.email,
              ]);
              this.changeDataTo(this.dynamicValidateForm.cascaderTo);
              this.refreshInput = false;
              setTimeout(() => {
                this.refreshInput = true;
              }, i * 75);
            }
          }
        }
        setTimeout(() => {
          this.$refs.refTo.inputValue = "";
          this.$refs.refTo.dropDownVisible = false;
        }, keywordArr.length * 75);
        this.$refs.refTo.handleClear();
      } else {
        if (node.data.toType == "user") {
          if (
            node.data.firstname.toLowerCase().indexOf(keyword.toLowerCase()) ===
            0
          ) {
            node.text = node.data.firstname + " " + node.data.lastname;
            return true;
          } else if (
            node.data.lastname.toLowerCase().indexOf(keyword.toLowerCase()) ===
            0
          ) {
            node.text = node.data.firstname + " " + node.data.lastname;
            return true;
          } else if (keyword.trim() === node.data.email) {
            this.dynamicValidateForm.cascaderTo.push([
              "user_" + node.data.email,
            ]);
            this.refreshInput = false;
            this.changeDataTo(this.dynamicValidateForm.cascaderTo);
            setTimeout(() => {
              this.refreshInput = true;
            }, 100);
            this.$refs.refTo.inputValue = "";
            this.$refs.refTo.dropDownVisible = false;
            this.$refs.refTo.handleClear();
          }
        } else {
          return (
            node
              .getText(false, null)
              .toLowerCase()
              .indexOf(keyword.toLowerCase()) >= 0
          );
        }
      }
    },
     prettyDate(datetime) {
      if (!datetime) return;
      const now = new Date();
      const target = new Date(datetime).toISOString().split('T')[0];
      var hours = Math.abs(new Date() - new Date(datetime)) / 36e5;
      now.setDate(now.getDate() - 1);
      const yesterday = now.toISOString().split('T')[0];

      // @see https://date-fns.org/v1.29.0/docs/format
      let result = format(datetime, "MMM D");
      const time = format(datetime, "h:mm A");
        if(hours<1){
          var diffMins = Math.round(((Math.abs(new Date() - new Date(datetime))  % 86400000) % 3600000) / 60000);
          result=diffMins+" minute ago"
        }else if(hours<24){
          result=Math.round(hours)+" hours ago"
        }else if (target == yesterday) {
        result = "Yesterday";
        result += ` at ${time}`;
        }else{
           result += ` at ${time}`;
        }

    
      

      return result;
    },
  },
};
</script>

<style lang="scss" scoped>
.barchart-style {
  border-radius: 4px;
}
.chart-container {
  border-radius: 24px;
  background: rgba(0,0,0,0.03);
}
.sub-title {
  text-transform: capitalize;
}
.bg-black-001 {
  background-color: rgba(000, 000, 000, 0.01);
}
.btn-add.small {
  font-size: 14px;
  height: 33px;
  width: 160px;
}
.icon-export {
  position: absolute;
  top: 3px;
  padding-left: 32px;
}
.grid-2-sesstion {
  display: grid;
  grid-template-columns: 400px auto;
}
.grid-left {
  min-height: 840px;
  max-height: 924px;
  > .header {
    height: 60px;
    padding-left: 40px;
    background-color: #6c30cc;
    color: #fff;
    font-weight: 800;
    font-size: 18px;
  }
  > .body {
    padding: 40px;
  }
}
.grid-right {
  padding: 60px 40px;
  background-color: #f8f8f8;
}
.bg-skeleton {
  background-color: #d8d8d8;
  border-radius: 3px;
  width: 100%;
}
.height-32 {
  height: 32px;
}
.height-25 {
  height: 25px;
}
.height-20 {
  height: 20px;
  width: 90px;
}
.height-cycle {
  border-radius: 10px;
  height: 20px;
  width: 20px;
}
.coin {
  &::before {
    content: "";
    background: #ffc75f;
    border-radius: 9px;
    height: 18px;
    width: 18px;
    position: absolute;
    left: -9px;
    top: -2px;
  }
}
.price-box {
  border-radius: 100px;
  padding: 5px 10px 5px 10px;
  border: 1px solid #00000029;
  position: absolute;
}
.mockup-icon {
  width: 24px;
  height: 24px;
  border-radius: 12px;
  margin: 6px 6px 0 0;
  background-color: #ededed;
}
.mini-icon {
  width: 16px;
  height: 16px;
}
.table-happily-village {
  font-size: 13px;
}
.recipients-modal {
  padding-left: 40px;
  padding-bottom: 16px;
  margin-top: -20px;
  margin-left: -20px;
  margin-right: -20px;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 6px 6px #00000014;
  opacity: 1;
}
.members-recipients {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 12px 0 0;
  margin: 0 0 0 16px;
  overflow-y: auto;
  overflow-x: hidden;
  max-height: 55vh;
}
.span-tag {
  margin-right: 6px;
}
.loading-box {
  border-radius: 4px;
  height: 48px;
  width: 100%;
  background-color: #f0f0f0;
  > .file {
    background-color: #e6e6e6;
    width: 48px;
    height: 48px;
    border-radius: 4px 0 0 4px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
  }
  > .name {
    width: calc(100% - 112px);
  }
  > .remove {
    transition: 0.3s;
    position: absolute;
    right: 0;
    width: 48px;
    font-size: 16px;
    &:hover > i {
      box-shadow: 0 0 10px 2px #f0f0f0;
    }
  }
}

.comment-contrainer {
  position: relative;
  padding: 60px 40px 40px;
  .comment-card {
    height: 538px;
    background-color: #fff;
    box-shadow: 0px 2px 4px #00000029;
    .comment-box {
      height: 490px;
      .comment {
        min-height: calc(70px - 36px);
        padding: 18px;
        display: grid;
        grid-template-columns: auto 60px;
        .content-comment {
          display: grid;
          grid-template-columns: 44px auto;
        }
        .content-comment-sub {
          display: grid;
          grid-template-columns: 24px 44px auto;
        }
        .img-preview {
          width: auto;
          max-width: 200px;
          max-height: 400px;
          object-fit: cover;
          background-color: rgba($color: #afafaf, $alpha: 0.4);
        }
      }
    }
    .no-comment {
      padding-top: 60px;
      text-align: center;
      color: #404243;
      font-size: 14px;
    }
    .input-container {
      background-color: #ebebeb;
      padding: 0 16px;
      height: 48px;
      display: grid;
      grid-template-columns: 44px auto 56px;
      .input-contain {
        background-color: #fff;
        border-radius: 3px;
        height: 30px;
        .reply-tag {
          background: #fff;
          border: 1px solid #ddd;
          border-radius: 3px;
          color: #afafaf;
          font-size: 11px;
          font-weight: 700;
          padding: 3px 6px 2px;
        }
      }
      .input-box {
        background-color: #fff;
        border: 0;
        border-radius: 3px;
        outline: 0;
        height: 30px;
        padding: 0 8px;
        width: calc(100% - 16px);
      }
      .mention-container {
        background-color: #fff;
        position: absolute;
        top: 0;
        max-height: 140px;
        padding: 2px 0;
        width: calc(100%);
        border-radius: 2px;
        box-shadow: 1px 1px 4px #ccc;
        .memeber-box {
          padding: 0 8px;
          height: 40px;
          font-size: 13px;
          cursor: pointer;
          transition: 0.3s;
          &:hover {
            background-color: rgba($color: #ccc, $alpha: 0.4);
          }
        }
      }
    }
  }
}
</style>

<style lang="scss">
#sessionModal {
  .comments-modal {
    .el-dialog__header {
      padding: 0;
      z-index: 2;
      position: relative;
    }
    .el-dialog__body {
      padding: 0;
    }
  }
  .grid-2-auto {
    gap: 16px;
  }
  .title {
    color: #2d2e36;
    font-weight: 700;
    font-size: 16px;
    margin: 16px 0 8px;
  }
  .el-input__inner,
  .el-textarea__inner {
    border: 0px;
    font-weight: 400;
  }
  .name > .el-input__inner {
    font-size: 18px;
  }
  .el-input__inner {
    font-size: 14px;
  }
  .el-textarea__inner {
    padding: 24px;
    font-size: 14px;
  }
  .el-date-editor.el-input,
  .el-select {
    width: 100%;
  }
}
</style>

